import { RxDashboard } from "react-icons/rx";
import { BsChatLeftText, BsBank, BsPeople, BsCalendar2Check, BsClipboardCheck } from "react-icons/bs"; // ✅ import icon

const Navlist = [
  {
    to: "",
    text: "Dashboard",
    icon: <RxDashboard />,
  },
  {
    to: "registered-collages",
    text: "Collages",
    icon: <BsBank />,
  },
  {
    to: "registered-students",
    text: "Students",
    icon: <BsPeople />,
  },
  {
    to: "manage-attendance", // ✅ new route
    text: "Manage Attendance",
    icon: <BsCalendar2Check />,
  }
 
];

export default Navlist;